import React, { lazy } from 'react';
import { CheckCircle2Icon, LockIcon, ShieldIcon, CreditCardIcon } from 'lucide-react';
import { PRICING, PAYMENT_LINK, BONUSES, MAIN_RESOURCES } from '../utils/constants';
import { CountdownTimer } from './CountdownTimer';
import { PaymentBadges } from './PaymentBadges';
import { PRODUCT_IMAGES } from '../utils/constants';
export function OfferSection() {
  const handlePurchase = () => {
    window.open(PAYMENT_LINK, '_blank');
  };
  return <section id="oferta" className="bg-gradient-to-b from-gray-50 to-white py-16 px-4 scroll-mt-20" data-id="element-142">
      <div className="max-w-4xl mx-auto" data-id="element-143">
        <div className="bg-white rounded-3xl shadow-2xl border-2 border-green-500 overflow-hidden" data-id="element-144">
          {/* Header */}
          <div className="bg-green-600 text-white py-6 px-8 text-center" data-id="element-145">
            <h2 className="text-3xl md:text-4xl font-bold" data-id="element-146">
              Accedi Ora al Mega-Pack
            </h2>
          </div>

          <div className="p-8 md:p-12" data-id="element-147">
            {/* Mini Pack Image */}
            <div className="relative h-[200px] mb-8" data-id="element-148">
              <img src={PRODUCT_IMAGES.tomo2} alt="" className="absolute left-[5%] top-[10%] w-[15%] transform -rotate-8 shadow-lg" loading="lazy" data-id="element-149" />
              <img src={PRODUCT_IMAGES.tomo3} alt="" className="absolute left-[20%] top-[5%] w-[15%] transform -rotate-4 shadow-lg" loading="lazy" data-id="element-150" />
              <img src={PRODUCT_IMAGES.main} alt="" className="absolute left-1/2 top-0 w-[22%] transform -translate-x-1/2 shadow-xl z-10" loading="lazy" data-id="element-151" />
              <img src={PRODUCT_IMAGES.tomo4} alt="" className="absolute right-[20%] top-[5%] w-[15%] transform rotate-4 shadow-lg" loading="lazy" data-id="element-152" />
              <img src={PRODUCT_IMAGES.tomo5} alt="" className="absolute right-[5%] top-[10%] w-[15%] transform rotate-8 shadow-lg" loading="lazy" data-id="element-153" />
            </div>

            {/* What's Included */}
            <div className="mb-8 space-y-3" data-id="element-154">
              {MAIN_RESOURCES.map((resource, index) => <div key={index} className="flex items-start gap-3" data-id="element-155">
                  <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-156" />
                  <div data-id="element-157">
                    <span className="font-semibold" data-id="element-158">{resource.title}</span>
                    <span className="text-gray-600 text-sm ml-2" data-id="element-159">
                      (89,99 €)
                    </span>
                  </div>
                </div>)}
              {BONUSES.map((bonus, index) => <div key={index} className="flex items-start gap-3" data-id="element-160">
                  <CheckCircle2Icon className="w-6 h-6 text-green-600 flex-shrink-0 mt-1" data-id="element-161" />
                  <div data-id="element-162">
                    <span className="font-semibold" data-id="element-163">{bonus.title}</span>
                    <span className="bg-red-600 text-white text-xs px-2 py-1 rounded ml-2" data-id="element-164">
                      GRATIS
                    </span>
                    <span className="text-gray-600 text-sm ml-2" data-id="element-165">
                      ({bonus.value})
                    </span>
                  </div>
                </div>)}
            </div>

            {/* Pricing */}
            <div className="border-t border-gray-200 pt-6 mb-6" data-id="element-166">
              <div className="text-center mb-4" data-id="element-167">
                <div className="text-gray-500 mb-2" data-id="element-168">Valore totale:</div>
                <div className="text-3xl font-bold text-gray-400 line-through" data-id="element-169">
                  {PRICING.totalValue}
                </div>
              </div>
              <div className="text-center mb-4" data-id="element-170">
                <div className="text-gray-500 mb-2" data-id="element-171">Prezzo normale:</div>
                <div className="text-3xl font-bold text-gray-400 line-through decoration-red-500 decoration-2" data-id="element-172">
                  {PRICING.originalPrice}
                </div>
              </div>
              <div className="text-center mb-4" data-id="element-173">
                <div className="text-gray-700 font-semibold mb-2" data-id="element-174">
                  Prezzo speciale oggi:
                </div>
                <div className="text-5xl md:text-6xl font-extrabold text-green-600" data-id="element-175">
                  17,99 <span className="text-3xl text-gray-500" data-id="element-176">€</span>
                </div>
                <div className="text-green-600 font-bold text-xl mt-2" data-id="element-177">
                  Risparmi {PRICING.savingsPercent}
                </div>
              </div>
            </div>

            {/* Countdown */}
            <div className="mb-6" data-id="element-178">
              <CountdownTimer data-id="element-179" />
            </div>

            {/* Purchase Button */}
            <button onClick={handlePurchase} className="w-full bg-green-600 hover:bg-green-700 text-white font-bold text-2xl py-6 rounded-2xl shadow-lg shadow-green-600/50 transition-all duration-300 animate-pulse mb-6" data-id="element-180">
              ACQUISTA ORA
            </button>

            {/* Payment Badges */}
            <div className="mb-6" data-id="element-181">
              <PaymentBadges data-id="element-182" />
            </div>

            {/* Trust Elements */}
            <div className="bg-green-50 border border-green-200 rounded-lg p-6 space-y-4 mb-6" data-id="element-183">
              <div className="flex items-start gap-3" data-id="element-184">
                <LockIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-185" />
                <div data-id="element-186">
                  <div className="font-bold text-gray-900" data-id="element-187">
                    Transazione Sicura al 100%
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-188">
                    Protetto con crittografia SSL a 256 bit
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-189">
                <ShieldIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-190" />
                <div data-id="element-191">
                  <div className="font-bold text-gray-900" data-id="element-192">
                    Garanzia 45 Giorni
                  </div>
                  <div className="text-sm text-gray-600" data-id="element-193">
                    Soddisfatti o rimborsati. Nessun rischio.
                  </div>
                </div>
              </div>
              <div className="flex items-start gap-3" data-id="element-194">
                <CreditCardIcon className="w-6 h-6 text-green-600 flex-shrink-0" data-id="element-195" />
                <div data-id="element-196">
                  <div className="font-bold text-gray-900" data-id="element-197">Pagamento Unico</div>
                  <div className="text-sm text-gray-600" data-id="element-198">
                    Nessun abbonamento. Nessun costo nascosto.
                  </div>
                </div>
              </div>
            </div>

            {/* Post-Purchase Steps */}
            <div className="bg-gray-50 border border-gray-200 rounded-lg p-6" data-id="element-199">
              <h3 className="font-bold text-gray-900 mb-4" data-id="element-200">
                Cosa succede dopo l'acquisto?
              </h3>
              <div className="space-y-3" data-id="element-201">
                <div className="flex items-start gap-3" data-id="element-202">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-203">
                    1
                  </div>
                  <p className="text-gray-700" data-id="element-204">
                    Riceverai un'email di conferma immediata
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-205">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-206">
                    2
                  </div>
                  <p className="text-gray-700" data-id="element-207">
                    Accederai subito a tutti i materiali digitali
                  </p>
                </div>
                <div className="flex items-start gap-3" data-id="element-208">
                  <div className="bg-blue-600 text-white w-8 h-8 rounded-full flex items-center justify-center font-bold flex-shrink-0" data-id="element-209">
                    3
                  </div>
                  <p className="text-gray-700" data-id="element-210">
                    Inizierai a usare il pack nella tua prossima lezione
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
}